import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { SessionService } from './session.service';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule
  ],
  declarations: [
  ],
  providers: [
    SessionService
  ]
})
export class SessionModule { }
